import { c as _c } from "react/compiler-runtime";
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { Box, Typography } from '@mui/material';
import type * as v from 'valibot';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import type { CreditCardsCardListItemSCSchema } from './schema';
export type CreditCardsCardListItemProps = StructuredContentDocumentWithRenderer<v.InferInput<typeof CreditCardsCardListItemSCSchema>>;
export const CreditCardsCardListItem = t0 => {
  const $ = _c(54);
  const {
    props
  } = t0;
  const {
    backgroundColor: t1,
    cardType: t2,
    header,
    imageUrl,
    imageAltText,
    children
  } = props;
  const backgroundColor = t1 === undefined ? "transparent" : t1;
  const cardType = t2 === undefined ? "shadowCard" : t2;
  const isShadowCard = cardType === "shadowCard";
  let t3;
  if ($[0] !== isShadowCard) {
    t3 = isShadowCard && {
      boxShadow: 2,
      borderRadius: "16px"
    };
    $[0] = isShadowCard;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3) {
    t4 = {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      ...t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      alignItems: "center",
      width: "100%"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== backgroundColor || $[6] !== cardType || $[7] !== header || $[8] !== imageAltText || $[9] !== imageUrl) {
    t6 = cardType === "imageCard" && imageUrl && <Box sx={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      background: backgroundColor,
      borderRadius: "4px"
    }}><CdnImage src={imageUrl} alt={imageAltText || `${header} image`} width={120} height={120} style={{
        objectFit: "contain",
        objectPosition: "center"
      }} /></Box>;
    $[5] = backgroundColor;
    $[6] = cardType;
    $[7] = header;
    $[8] = imageAltText;
    $[9] = imageUrl;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = isShadowCard ? 0 : 3;
  let t8;
  if ($[11] !== t7) {
    t8 = {
      display: "flex",
      flexDirection: "column",
      gap: t7,
      width: "100%"
    };
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = isShadowCard ? 3 : 0;
  let t10;
  if ($[13] !== isShadowCard) {
    t10 = isShadowCard && {
      borderTopRightRadius: "16px",
      borderTopLeftRadius: "16px",
      bgcolor: "yellows.lighter-2"
    };
    $[13] = isShadowCard;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = {
      padding: t9,
      ...t10
    };
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== isShadowCard) {
    t12 = isShadowCard ? "14px" : {
      xs: "16px",
      sm: "18px"
    };
    $[18] = isShadowCard;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = isShadowCard ? "left" : "center";
  let t14;
  if ($[20] !== t13) {
    t14 = {
      xs: t13,
      sm: "left"
    };
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t12 || $[23] !== t14) {
    t15 = {
      fontWeight: "bold",
      fontSize: t12,
      lineHeight: "24px",
      textAlign: t14
    };
    $[22] = t12;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== header || $[26] !== t15) {
    t16 = <Typography sx={t15}>{header}</Typography>;
    $[25] = header;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t11 || $[29] !== t16) {
    t17 = <Box sx={t11}>{t16}</Box>;
    $[28] = t11;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  const t18 = isShadowCard ? 3 : 0;
  let t19;
  if ($[31] !== isShadowCard) {
    t19 = isShadowCard ? "center" : {
      xs: "center",
      sm: "left"
    };
    $[31] = isShadowCard;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== isShadowCard) {
    t20 = isShadowCard ? "14px" : {
      xs: "14px",
      sm: "16px"
    };
    $[33] = isShadowCard;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t18 || $[36] !== t19 || $[37] !== t20) {
    t21 = {
      display: "flex",
      padding: t18,
      justifyContent: "center",
      textAlign: t19,
      fontSize: t20,
      lineHeight: "24px"
    };
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== children) {
    t22 = renderStructuredContent(children);
    $[39] = children;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t21 || $[42] !== t22) {
    t23 = <Box sx={t21}>{t22}</Box>;
    $[41] = t21;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t17 || $[45] !== t23 || $[46] !== t8) {
    t24 = <Box sx={t8}>{t17}{t23}</Box>;
    $[44] = t17;
    $[45] = t23;
    $[46] = t8;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t24 || $[49] !== t6) {
    t25 = <Box sx={t5}>{t6}{t24}</Box>;
    $[48] = t24;
    $[49] = t6;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t25 || $[52] !== t4) {
    t26 = <Box sx={t4}>{t25}</Box>;
    $[51] = t25;
    $[52] = t4;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  return t26;
};